import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

export default ({ apiKey, children }) => {
  const [stripePromise, setStripePromise] = useState(null);
  useEffect(() => {
    if (apiKey && !stripePromise) {
      setStripePromise(loadStripe(apiKey));
    }
  }, [apiKey, stripePromise]);
  return <Elements stripe={stripePromise}>{children}</Elements>;
};
